import React, {useCallback} from 'react';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {statusPageAPI} from 'features/statusPage/api/statusPageAPI';
import {fetchMe} from 'entities/user';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IStatusPage from 'features/statusPage/model/StatusPage/IStatusPage';
import {TypedDispatch} from 'shared/model/types';

interface IStatusPageDeleteModalProps {
    item: IStatusPage,
    open: boolean;
    handleClose: () => void;
}

const StatusPageDeleteModal: React.FC<IStatusPageDeleteModalProps> = ({item, open, handleClose}) => {
    const [deleteStatusPage, {isLoading}] = statusPageAPI.useDeleteStatusPageMutation();
    const dispatch = useDispatch<TypedDispatch>();

    const onClickDelete = useCallback(async() => {
        const result = await deleteStatusPage(item.uuid);
        if ('error' in result) return;
        toast.info(t`Страница статуса удалена`);
        dispatch(fetchMe());
        handleClose();
    }, [deleteStatusPage, item.uuid, dispatch, handleClose]);

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление страницы статуса`}
            title={t`Удалить страницу статуса`}
            name={item.name}
            hint={
                <Trans
                    id="modal.statusPage.delete.text"
                    message="Страница станет недоступна по ссылке. Это действие нельзя отменить."
                />
            }
            confirmText={t`Удалить`}
            onConfirm={onClickDelete}
            isLoading={isLoading}
        />
    );
};

export default StatusPageDeleteModal;
